import { FinalTechMapTable } from './ui';

export { FinalTechMapTable };
